var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.legalPostscriptum)?_c('div',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"row small"},[_vm._v("\n        "+_vm._s(_vm.legalPostscriptum)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }